const initialState = [
  {
    Data: [],
  },
];

const activateDeviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ACTIVATE_DEVICE":
      return {
        ...state,
        Data: action.payload
      }
    default:
      return state;
  }
};

export default activateDeviceReducer;
